import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import {CURRENCY, CURRENCY_CODE, DROPZONE_ACCEPTED_FILES, DROPZONE_ACCEPTED_FILES_ARRAY} from "../../helpers/variables";
import { arrayUnique, getDateQuestionMaximumValue, getDateQuestionMinimumValue } from "../../helpers/questions/functions";
import { FormGroup, InfoTooltip } from 'arag-ui-lib';
import moment from 'moment';
import {validateAmount, formatNumber} from "../../helpers/functions";
import { formGroupVariants, secondaryVariantStyle, inputType } from '../../helpers/formGroupVariants';

const PolicyTabUpdateQuestion = (props) => {
    // should question be hidden based on the selected case result?
    const [questionValidation, setQuestionValidation] = useState({})

    const validateAmountTypeQuestion = (questionId,value,minimum) => {
        var errMsg = validateAmount(value, minimum);
        setQuestionValidation({...questionValidation,[questionId]:errMsg});
        return errMsg; 
    }
 
   
    const isMandatory = props.shouldUpdateQuestionBeMandatory(props.question);   

    const handleBlur = (questionId, value, minValue) => {        
        const errMsg = validateAmountTypeQuestion(questionId, value, minValue);          
        if (!errMsg) {
            const formattedValue = formatNumber(props.formData[questionId]);
            props.HandleFormCompChange(questionId, formattedValue);
        }
    }; 

    useEffect(() => {
        if (props.question.inputType === inputType.amount && props.formData[props.question.id]) {   
            const formattedValue = formatNumber(props.formData[props.question.id]);              
            if (formattedValue !== props.formData[props.question.id]) {
                props.HandleFormCompChange(props.question.id, formattedValue);
            }
        }
    }, [props.question.id]);
    
    if (!isMandatory) {
        return null;
    }

    //calendar question?
    if(props.question.inputType === inputType.calendar){
        let value =  props.formData[props.question?.id];
        // date field
        let maxDate , minDate ;
        minDate = getDateQuestionMinimumValue(props.question, props.formData, props.allQuestions);
        maxDate = getDateQuestionMaximumValue(props.question, props.formData, props.allQuestions);
        minDate = moment(minDate,"DD/MM/YYYY").format("YYYY/MM/DD");
        maxDate = moment(maxDate,"DD/MM/YYYY").format("YYYY/MM/DD");
        //When new application components get update please rework logic without "moment" library. 
        return (
            <div class='parent inline-flex-parent'>
                <FormGroup
                    labelSize="col-sm-4"
                    inputSize="col-sm-6"
                    label={props.question.name}
                    variant={formGroupVariants.date}
                    inputProps={{
                        required:props.question?.isRequired,
                        label:props.question?.name, 
                        dateInputProps: {
                            type:props.question.id,
                            name:props.question.id,
                            onChange:  (e) => props.HandleDateChange(props.question?.id,new Date(e),minDate,maxDate),
                            minDate:new Date(minDate),
                            maxDate:new Date(maxDate),
                            autoComplete: 'off' ,
                            dateFormat: 'dd/MM/yyyy',
                            selected: value,
                            required:props.question.isRequired,
                            placeholderText : 'DD/MM/YYYY'
                        }
                    }}
                    requiredStyle={secondaryVariantStyle}
                    formGroupTestId={`policy-update-${props.question.machineName}`}
                />
                {
                    props.question.tooltip != null ?
                        <div className={'col-sm-12 col-sm-offset-10'} style={{bottom:'48px',right:'15px'}} >
                            <InfoTooltip
                                text={(<div className="InfoTooltip" dangerouslySetInnerHTML={{ __html: props.question.tooltip }} />)}
                                variant="info"
                                style={{}}
                                miscellaneousCharacter=""
                                tooltipTestId={`policy-update-${props.question.machineName}-info`}
                            />
                        </div> : null
                }
            </div>
        )
    }

    //amount question?
    if(props.question.inputType === inputType.amount){
        return (
            <div className='currencyField'>
                <FormGroup
                    errorMessage={questionValidation[props?.question?.id]}
                    labelSize="col-sm-4"
                    inputSize="col-sm-6"
                    label={props?.question?.name}
                    variant={formGroupVariants.currency}
                    inputProps={{
                        value: props.formData[props?.question?.id],
                        key: props.question.id,
                        onBlur: () => handleBlur(props?.question?.id,props.formData[props?.question?.id],props?.question?.minimumValue),
                        name: `${props?.question?.id}`,
                        onChange: (e) => {
                            props.HandleFormCompChange(e.target.name, e.target.value);
                            validateAmountTypeQuestion(e.target.name,e.target.value,null);
                        },
                        disabledDropdown: true,
                        handleOptionSelect: () => { },
                        menuOptions: [{ sign: '£', code: 'GBP' }, { sign: '$', code: 'CAN' }],
                        selectedCurrency: { sign: `${CURRENCY}`, code: `${CURRENCY_CODE}` },
                        required: props?.question?.isRequired
                    }}
                    requiredStyle={secondaryVariantStyle}
                    formGroupTestId={`policy-update-${props.question.machineName}`}
                />
            </div>
        )
    }

    //text question?
    if(props.question.inputType === inputType.text){
        return (
            <FormGroup
                labelSize="col-sm-4"
                inputSize="col-sm-6 formGroup-textInput-input-wrapper"
                required={props.question?.isRequired}
                label={props.question?.name}
                variant={formGroupVariants.text}
                inputProps={{
                    onChange: (evt) => props.HandleFormCompChange(evt.target.name,evt.target.value),
                    name: `${props.question?.id}`,
                    value: props.formData[props.question?.id],
                    key:props.question?.id,
                    required:props.question?.isRequired
                }}
                requiredStyle={secondaryVariantStyle}
                formGroupTestId={`policy-update-${props.question.machineName}`}
            />
        )
    }

    //text area question?
    if(props.question.inputType === inputType.textArea){
        return (
            <FormGroup
                labelSize="col-sm-4"
                inputSize="col-sm-6"
                label={props.question.name}
                variant={formGroupVariants.textarea}
                required={props.question.isRequired}
                inputProps={{
                    onChange:(evt) => props.HandleFormCompChange(props.question.id,evt.target.value),
                    name: `${props.question?.id}`,
                    value: props.formData[props.question?.id],
                    key: props.question?.id,
                    required:props.question?.isRequired,
                    rows:6
                }}
                requiredStyle={secondaryVariantStyle}
                formGroupTestId={`policy-update-${props.question.machineName}`}
            />
        )
    }

    //drop down question?
    if(props.question.inputType === inputType.dropDown){
        let selectedOption = _.find(props.question.options, o => {return o.id && props.formData[props.question.id] && o.id.toString() === props.formData[props.question.id].toString()});
        let childQuestions  = [];
        if(selectedOption){
            childQuestions  = _.filter(props.allQuestions, q => {return _.find(selectedOption.childQuestions, cq => {return cq.id === q.id})});
        }
        return (
            <div>
                <FormGroup
                    labelSize="col-sm-4"
                    inputSize="col-sm-6"
                    label={props.question.name}
                    variant={formGroupVariants.select}
                    required={props.question.isRequired}
                    key={props.question.id}
                    inputProps={{
                        onChange:props.HandleSelectChange,
                        options: [{key:'',value: '', label: 'None'}, ...props.question.options.map(o => ({key:o.id,value: o.id, label: o.name}))],
                        value: props.formData[props.question.id],
                        key:props.question.id,
                        name: `${props.question.id}`,
                        required:props.question.isRequired
                    }}
                    requiredStyle={secondaryVariantStyle}
                    formGroupTestId={`policy-update-${props.question.machineName}`}
                />
                 {
                    props.question.tooltip != null 
                    ?   <div className={'col-sm-12 col-sm-offset-10'} style={{bottom:'48px',right:'15px'}} >
                            <InfoTooltip
                                text={(<div className="InfoTooltip" dangerouslySetInnerHTML={{ __html: props.question.tooltip }} />)}
                                variant="info"
                                style={{}}
                                miscellaneousCharacter=""
                                tooltipTestId={`policy-update-${props.question.machineName}-info`}
                            />
                        </div> 
                    :   null
                }
                {
                    _.sortBy(childQuestions,['sortOrder']).map(cq => {
                        return (
                            <PolicyTabUpdateQuestion
                                shouldUpdateQuestionBeMandatory={props.shouldUpdateQuestionBeMandatory}
                                allQuestions={props.allQuestions}
                                key={cq.id}
                                HandleSelectChange={props.HandleSelectChange}
                                HandleFormCompChange={props.HandleFormCompChange}
                                HandleDateChange={props.HandleDateChange}
                                question={cq}
                                formData={props.formData}
                                OnDrop={props.OnDrop}
                                onDropMultiple={props.onDropMultiple}
                                onDropSingle={props.onDropSingle}
                            />
                        )
                    })
                }
            </div>
        )
    }

    if (props.question.inputType === inputType.upload) {
        const fileValue= props.formData[props.question.id] ? props.formData[props.question.id].map((f,index) => ({...f,value:index,label:f.name})):[];

        return <div>
            <FormGroup
                labelSize="col-sm-4"
                inputSize="col-sm-6"
                label={props.question.name}
                variant={formGroupVariants.file}
                key={props.question.id}
                name={props.question.id}
                required={props.question.isRequired}
                inputProps={{
                    key:props.question.id,
                    name: props.question.id,
                    label:fileValue[0]? fileValue[0].name : 'Add file...' ,
                    accepts: DROPZONE_ACCEPTED_FILES,
                    allowMultiple: false,
                    required:props.question.isRequired,
                    onDrop: (evt) => props.onDropSingle(evt,props.question.id)
                }}
                requiredStyle={secondaryVariantStyle}
                formGroupTestId={`policy-update-${props.question.machineName}`}
            />
        </div>
    }
    if (props.question.inputType === inputType.multiUpload) {
        const filesValues = props.formData[props.question.id] ? props.formData[props.question.id].map((f,index) => ({...f,value:index,label:f.name})) : [];
        const duplicateFileNames = arrayUnique(filesValues.map(f => f.name));
        const uploadedFilesText = filesValues.map(file => file.name).join(", ");

        return (
            <div className='form-group'>
                <div className='multiSelectField'>
                    <FormGroup
                        labelSize={"col-md-4"}
                        inputSize={"col-md-6"}
                        key={props.question.id}
                        label={props.question.name}
                        variant={formGroupVariants.file}
                        required={props.question.isRequired}
                        name={props.question.id}
                        inline
                        errorMessage={duplicateFileNames.length != filesValues.length ? "Please remove duplicate files" : ""}
                        helpText={uploadedFilesText}
                        inputProps={{
                            key: props.question.id,
                            name: props.question.id,
                            label:filesValues.length ? "Add more files..." : 'Add file...' ,
                            accepts: DROPZONE_ACCEPTED_FILES_ARRAY,
                            allowMultiple: true,
                            required: props.question.isRequired,
                            onDrop: (evt) => props.onDropMultiple(evt,props.question.id),
                        }}
                        requiredStyle={secondaryVariantStyle}
                        formGroupTestId={`policy-update-${props.question.machineName}`}
                    />
                </div>
            </div>
        )
    }

    if (props.question.inputType === inputType.noInput) {
        return <div>
            <FormGroup
                labelSize={'col-sm-12'}
                inputSize={'col-sm-12'}
                label={""}
                variant={formGroupVariants.plain}
                inputProps={{
                    label: (
                        <strong>
                            {props.question.name}
                        </strong>
                    ),
                }}
                formGroupTestId={`policy-update-${props.question.machineName}`}
            />
        </div>
    }

    return null
};

export default PolicyTabUpdateQuestion;